import { Slide, ToastContainer } from 'react-toastify';

import s from './ToastProvider.module.css';

const ToastProvider = () => (
  <ToastContainer
    autoClose={2500}
    className={s.layout}
    closeButton={false}
    closeOnClick={false}
    draggable={false}
    icon={false}
    limit={3}
    pauseOnFocusLoss={false}
    pauseOnHover={false}
    position="top-center"
    theme="dark"
    toastClassName={s.toast}
    transition={Slide}
    hideProgressBar
  />
);

export { ToastProvider };
